/**
 * The campaigns screens' header (list and detail) sets the h1 at 28/36, one
 * step under the product-wide 30/38 that `PageShell` inherits from `fontSizeHeading1`. Scoped with a nested
 * provider — not CSS — so it stays a theme value (see the
 * `silia-ui-components` skill, "Only on your screen").
 */
export const CAMPAIGNS_HEADER_THEME = {
  components: { Typography: { fontSizeHeading1: 28, lineHeightHeading1: 36 / 28 } },
};
